import React, { useState } from 'react';

const PopupComponent = () => {
    const [showPopup, setShowPopup] = useState(false);

    const handleOpenPopup = () => {
        setShowPopup(true);
    };

    const handleClosePopup = () => {
        setShowPopup(false);
    };

    return (
        <div>
            <button onClick={handleOpenPopup}>Mostrar Popup</button>
            {showPopup && (
                <div style={{ position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', backgroundColor: 'white', padding: '20px', zIndex: 1000 }}>
                    <p>Por favor, ingrese los datos.</p>
                    <button onClick={handleClosePopup}>Cerrar</button>
                </div>
            )}
            {showPopup && (
                <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 999 }} onClick={handleClosePopup}></div>
            )}
        </div>
    );
};

export default PopupComponent;
